module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"virtual_crossmatch":"Virtual Crossmatch"},"fr":{"virtual_crossmatch":"Compatilbilité croisée virtuelle"}}')
  delete Component.options._Ctor
}
